import { render, staticRenderFns } from "./GameDefaultList.vue?vue&type=template&id=0f023cf1&scoped=true"
import script from "./GameDefaultList.vue?vue&type=script&lang=js"
export * from "./GameDefaultList.vue?vue&type=script&lang=js"
import style0 from "./GameDefaultList.vue?vue&type=style&index=0&id=0f023cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f023cf1",
  null
  
)

export default component.exports